import React from 'react';
import PropTypes from 'prop-types';
import Link from './link';
import { getBrandfolderAsset } from '../contentful/brandfolder-lookup';

const LinkBrandfolder = ({
  children, targetId, brandfolder, ...other
}) => {
  console.log(brandfolder);
  // const page = getBrandfolderAsset(targetId);
  return (
    <span>
      <span>[INSERT WIDGET TO DOWNLOAD BRANDFOLDER ATTACHMENTS HERE]</span>
      &nbsp;
      {children}
    </span>
  );

  // return the first path available
  // if (page && page.length > 0) {
  //   return (
  //     <Link to={page[0].path} {...other}>
  //       {children}
  //     </Link>
  //   );
  // }
  // if the page can't be found get rid of the <a> tag but keep the content within
  // return children;
};

LinkBrandfolder.propTypes = {
  targetId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default LinkBrandfolder;
